import { useSearchParam } from 'components/search/search.hooks';
import { useHasAllMerchantLocationAccess } from 'hooks/authorization.hooks';

/**
 * Whether the Active Customers tab's "all-locations-only" sections — New
 * Members, Conversion Rate to First Order, and the Acquisition Source chart —
 * should be hidden. These metrics need a brand-wide reach population, so they're
 * shown only to an all-locations admin viewing all locations; hide them for a
 * location-scoped admin, or whenever the report is filtered to specific stores
 * (the BE also nullifies the matching cards).
 */
export const useHideAllLocationSections = (): boolean => {
  const hasAllLocationAccess = useHasAllMerchantLocationAccess();
  const storeIds = useSearchParam<string[]>('storeIds')?.value ?? [];
  const hasSpecificLocations = storeIds.length > 0 && !storeIds.includes('ALL');
  return !hasAllLocationAccess || hasSpecificLocations;
};
